import React, { useEffect } from 'react';
import '../styles/LegalPage.css';
import { useTranslation } from 'react-i18next';

const LegalPage = () => {
	const { t } = useTranslation();

	// Scroll to top on mount
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="legal-container">
			<div className="legal-content">
				<header className="legal-header">
					<h1>Právní informace Scoreo</h1>
					<p>Poslední aktualizace: 11.1.2026</p>
				</header>

				<section id="terms" className="legal-section">
					<h2>I. Podmínky použití (Terms of Service)</h2>

					<h3>1. Charakter služby</h3>
					<p>
						Aplikace <strong>Scoreo</strong> je platforma pro sociální tipování sportovních výsledků.
						Veškeré funkce jsou poskytovány <strong>zdarma</strong>. Aplikace nevyžaduje žádné vklady reálných peněz
						a neumožňuje získání žádných finančních výher ani cen s peněžní hodnotou.
						Nejedná se o hazardní hru ani sázkovou kancelář.
					</p>

					<h3>2. Registrace a bezpečnost</h3>
					<p>
						Registrací prostřednictvím e-mailu nebo účtu Google získáváte přístup k osobnímu účtu.
						Jste zodpovědní za udržování tajnosti svých přihlašovacích údajů.
						Provozovatel neodpovídá za zneužití účtu způsobené nedbalostí uživatele.
					</p>

					<h3>3. Správnost dat a výsledků</h3>
					<p>
						Data o zápasech a výsledcích jsou čerpána z externích zdrojů (API třetích stran).
						Provozovatel neručí za jejich správnost, aktuálnost ani případné chyby v automatickém vyhodnocování tipů.
						V případě zjištění chyby v datech se provozovatel pokusí o nápravu, ale uživatel nemá nárok na žádnou kompenzaci.
					</p>

					<h3>4. Pravidla chování a Fair-Play</h3>
					<p>
						Je zakázáno používat automatizované nástroje (boty) k odesílání tipů nebo se pokoušet o zneužití technických chyb systému.
						Administrátoři mají právo bez předchozího upozornění smazat účet nebo upravit skóre uživatele,
						pokud dojde k podezření z podvodného jednání nebo narušování chodu aplikace.
					</p>

					<h3>5. Omezení odpovědnosti</h3>
					<p>
						Služba je provozována na infrastruktuře třetích stran (Render) v lokalitě EU Central.
						Provozovatel nenese odpovědnost za dočasné výpadky služby, ztrátu dat nebo nedostupnost aplikace
						způsobenou technickými faktory mimo jeho přímou kontrolu.
					</p>
				</section>

				<hr className="legal-divider" />

				<section id="privacy" className="legal-section">
                    <h2>II. Ochrana osobních údajů (Privacy Policy)</h2>
                    
                    <p>
                        Vaše soukromí je pro nás prioritou. Vaše data neprodáváme.
                    </p>

                    <h3>1. Rozsah zpracovávaných údajů</h3>
                    <ul>
                        <li><strong>Údaje o účtu:</strong> E-mailová adresa, uživatelské jméno a zašifrované heslo.</li>
                        <li><strong>Sociální přihlášení:</strong> Identifikátor poskytnutý službou Google v případě využití Google Login.</li>
                        <li><strong>Herní data:</strong> Tipy na zápasy, členství v ligách a získaná ocenění.</li>
                    </ul>

                    <h3>2. Účel zpracování</h3>
                    <ul>
                        <li><strong>Provoz služby:</strong> Autentizace, vyhodnocování tipů a správa žebříčků.</li>
                        <li><strong>Bezpečnost:</strong> Ochrana proti zneužití (např. CSRF ochrana).</li>
                    </ul>

                    <h3>3. Analytika a soukromí</h3>
                    <p>
                        Pro měření návštěvnosti používáme nástroj <strong>Plausible Analytics</strong>. 
                        Tento nástroj je zvolen pro svou šetrnost k soukromí – nesleduje uživatele napříč weby a neshromažďuje osobní údaje.
                    </p>

                    <h3>4. Ukládání dat a hosting</h3>
                    <p>
                        Vaše osobní data jsou uložena v rámci infrastruktury společnosti <strong>Render</strong>. 
                        Servery jsou fyzicky umístěny v lokalitě <strong>EU Central</strong>, což zajišťuje, že zpracování dat probíhá v souladu s evropskými standardy ochrany osobních údajů (GDPR).
                    </p>

                    <h3>5. Soubory cookies a lokální úložiště</h3>
                    <ul>
                        <li>Udržení přihlášení (JWT tokeny).</li>
                        <li>Zabezpečení požadavků (XSRF-TOKEN).</li>
                        <li>Uložení jazykové preference.</li>
                    </ul>

                    <h3>6. Vaše práva a kontakt</h3>
                    <p>
                        Máte právo na přístup ke svým údajům, jejich opravu nebo úplný výmaz (zrušení účtu). 
                        V případě dotazů nás kontaktujte na: <strong>kontakt@scoreo.cz</strong>.
                    </p>
                </section>
			</div>
		</div>
	);
};

export default LegalPage;